var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX12Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.314,
    height: 11.314,
    viewBox: "0 0 11.314 11.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(-401.343 -307.343)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(401.343 317.242) rotate(-45)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(411.243 318.656) rotate(-135)",
    fill: "#d3d3d3"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX12Px);
export default __webpack_public_path__ + "static/media/x-12px.12e8b79d.svg";
export { ForwardRef as ReactComponent };